import { Button, Result } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { callEventTrackingOp, useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { loginActions } from '../../../../pages/LoginPage/reducer';
import { OP_STATUS } from '../../../../util/varibles/constants';
import { IHarvest2 } from '../../../../util/varibles/interface';
import Icon, { ICON_NAME } from "../../../Icon";
import HarvestSteps from '../../_components/HarvestSteps';
import Header from "../../_components/Header2";
import NextStep from '../../_components/StepControl/NextStep';
import stylesOp from "../style.module.scss";

const Views: { [id: string]: React.FC } = {
    [OP_STATUS.APPROVED]: () => {
        return <div className='flex justify-center mt-5'>
            <NextStep name='start operation'>
                Start operation
            </NextStep>
        </div>
    },
    [OP_STATUS.PROCESSING]: () => {
        return <HarvestSteps />
    },
    [OP_STATUS.FINISHED]: () => {
        const dispatch = useDispatch();
        return <Result
            status="success"
            title={<div className='font-s16 font-w4'>Operation is completed</div>}
            extra={<div className='flex justify-content-center'>
                <Button className='bt-primary' onClick={() => dispatch(loginActions.getOpsOfVessel())}>
                    Continue
                </Button>
            </div>}
        />
    }
}

const Harvest: React.FC = () => {
    const [op] = useTrackingOp(state => state.op?.operation as IHarvest2);
    const { getWeather } = callEventTrackingOp();

    useEffect(() => {
        getWeather();
    }, [getWeather])

    if (!op) return null;

    const { site, sites = [], factory_name, status } = op;
    const { name: siteName = '' } = site || sites[0] || {};
    const { [status || ""]: View } = Views;

    return <div className="flex flex-col h-full">
        <Header icon={<Icon icon={ICON_NAME.HARVEST} />}>
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span className='whitespace-nowrap'>{siteName}</span>
                <span className='arrow-right' />
                <span className='whitespace-nowrap'>{factory_name}</span>
            </div>
        </Header>
        <div className="flex-1 overflow-y-auto ml-[-20px] w-[calc(100% + 40px)]">
            {View && <View />}
        </div>
    </div>;
};

export default Harvest;
